import { render, staticRenderFns } from "./BulletedList.vue?vue&type=template&id=2aa3612d&"
import script from "./BulletedList.vue?vue&type=script&lang=js&"
export * from "./BulletedList.vue?vue&type=script&lang=js&"
import style0 from "./BulletedList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports